import React from 'react'
import { Button, Spinner } from 'react-bootstrap'

const SpinnerButton = ({
    onClick = () => {},
    variant = 'primary',
    disabled,
    busy,
    children
}) => {
    return (
        <Button disabled={disabled} onClick={onClick} variant={variant}>
            {!busy && <React.Fragment>{children}</React.Fragment>}
            {busy &&
                <React.Fragment><Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                /><span style={{ paddingLeft: '5px' }}>{children}</span></React.Fragment>}
        </Button>
    )
}

export default SpinnerButton